import React from 'react';
const courseOverview = ['Introduction to Concealed Carry and the Defensive Mindset', 'Introduction to Self-Defense and Concealed Carry', 'Legal Aspects of Concealed Carry and Self-Defense', 'Carry Modes and Concealment', 'Presenting the Handgun from Concealment', 'Presentation, Position, and Movement', 'Special Shooting Techniques', 'Sport Shooting Activities and Training Opportunities', 'Course Review and Examination'];
export function CourseOverview() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2336">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2337">
        <div className="mb-12" data-id="element-2338">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-2339">
            Course Overview
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2340">
            <ol className="space-y-4" data-id="element-2341">
              {courseOverview.map((section, index) => <li key={index} className="flex items-start gap-4" data-id="element-2342">
                  <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 font-bold text-xs" style={{
                backgroundColor: 'rgba(30,61,47,0.08)',
                color: '#1e3d2f',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-2343">
                    {['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'][index]}
                  </div>
                  <span className="text-base text-gray-800 pt-1" style={{
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-2344">
                    {section}
                  </span>
                </li>)}
            </ol>
          </div>
        </div>
      </div>
    </div>;
}